import { createFileRoute, redirect } from '@tanstack/react-router'
import { AiFeedbackPage } from '@unsw/features/admin-dashboard'
import { getUserRole } from '@unsw/hooks'

export const Route = createFileRoute('/dashboard/ai-feedback')({
  beforeLoad: () => {
    const { isAdmin } = getUserRole()
    if (!isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AiFeedbackRoute,
})

function AiFeedbackRoute() {
  return <AiFeedbackPage />
}
